import React from 'react';
import Skeleton from '../../../../components/Skeleton';

const SurveyTableLoader = ({ rowCount = 5, columnCount = 6 }) => {
  return (
    <div>
      <div className="border-b py-3 px-4 gap-[20px] flex items-center justify-between">
        <Skeleton className="w-[200px] h-[30px]" />
        {Array.from({ length: columnCount })
          .fill()
          .map((d, i) => (
            <Skeleton className="w-[100px] h-[30px]" key={i} />
          ))}
      </div>
      <div className=" py-3 px-4 space-y-3">
        {Array.from({ length: rowCount })
          .fill()
          .map((d, i) => (
            <div
              key={i}
              className="border-b py-3  gap-[20px] flex items-center justify-between"
            >
              <div className="space-y-2">
                <Skeleton className="w-[180px] h-[20px]" />
                <div className="flex items-center gap-[10px]">
                  {[1, 2]?.map((el, ind) => (
                    <Skeleton className="w-[80px] h-[10px]" key={ind} />
                  ))}
                </div>
              </div>
              {Array.from({ length: columnCount })
                .fill()
                .map((dd, ii) => (
                  <Skeleton className="w-[80px] h-[20px]" key={ii} />
                ))}
            </div>
          ))}
      </div>
    </div>
  );
};

export default SurveyTableLoader;
